<template>
  <div>
    <v-row dense>
      <v-col
        cols="12"
        lg="5"
      >
        <material-invoices-and-quotations-quotations-card
          :client-id="clientId"
        />
      </v-col>
      <v-col
        cols="12"
        lg="7"
      >
        <material-invoices-and-quotations-invoices-card
          :client-id="clientId"
        />
      </v-col>
      <v-col data-cy="bank-account-card">
        <material-invoices-and-quotations-bank-contact-card />
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  computed: {
    clientId () {
      return this.$route.params.clientId
    }
  }
}
</script>
